export const HEIGHT_MAP = {
  small: "var(--button-height-small)",
  medium: "var(--button-height-medium)",
  big: "var(--button-height-big)",
};

export const VARIANT_STYLES = {
  primary: {
    default: {
      normal: {
        backgroundColor: "var(--button-primary-bg)",
        color: "var(--button-primary-text)",
        border: "1px solid transparent",
        boxShadow: "none",
      },
      hover: {
        backgroundColor: "var(--button-primary-bg-hover)",
      },
      focus: {
        backgroundColor: "var(--button-primary-bg-focus)",
      },
      disabled: {
        backgroundColor: "var(--button-primary-bg-disabled)",
        color: "var(--button-primary-text)",
      },
    },
    danger: {
      normal: {
        backgroundColor: "var(--button-danger-primary-bg)",
        color: "var(--button-danger-primary-text)",
        border: "1px solid transparent",
        boxShadow: "none",
      },
      hover: {
        backgroundColor: "var(--button-danger-primary-bg-hover)",
      },
      focus: {
        backgroundColor: "var(--button-danger-primary-bg-focus)",
      },
      disabled: {
        backgroundColor: "var(--button-danger-primary-bg-disabled)",
        color: "var(--button-danger-primary-text)",
      },
    },
  },
  secondary: {
    default: {
      normal: {
        backgroundColor: "var(--button-secondary-bg)",
        color: "var(--button-secondary-text)",
        border: "1px solid var(--button-secondary-border)",
        boxShadow: "none",
      },
      hover: {
        backgroundColor: "var(--button-secondary-bg-hover)",
        border: "1px solid var(--button-secondary-border)",
      },
      focus: {
        backgroundColor: "var(--button-secondary-bg)",
        color: "var(--button-secondary-text)",
        border: "1px solid var(--button-secondary-border)",
      },
      disabled: {
        backgroundColor: "var(--button-secondary-bg-disabled)",
        color: "var(--button-secondary-text-disabled)",
        border: "1px solid var(--button-secondary-border)",
      },
    },
    transparent: {
      normal: {
        backgroundColor: "transparent",
        color: "var(--button-secondary-text)",
        border: "1px solid var(--button-secondary-border)",
        boxShadow: "none",
      },
      hover: {
        backgroundColor: "var(--button-secondary-bg-hover)",
        border: "1px solid var(--button-secondary-border)",
      },
      focus: {
        backgroundColor: "transparent",
        color: "var(--button-secondary-text)",
        border: "1px solid var(--button-secondary-border)",
      },
      disabled: {
        backgroundColor: "var(--button-secondary-bg-disabled)",
        color: "var(--button-secondary-text-disabled)",
        border: "1px solid var(--button-secondary-border)",
      },
    },
    danger: {
      normal: {
        backgroundColor: "var(--button-danger-secondary-bg)",
        color: "var(--button-danger-secondary-text)",
        border: "1px solid var(--button-danger-secondary-border)",
        boxShadow: "none",
      },
      hover: {
        backgroundColor: "var(--button-danger-secondary-bg-hover)",
        color: "var(--button-danger-secondary-text)",
        border: "1px solid var(--button-danger-secondary-border)",
      },
      focus: {
        backgroundColor: "var(--button-danger-secondary-bg)",
        color: "var(--button-danger-secondary-text)",
        border: "1px solid var(--button-danger-secondary-border)",
      },
      disabled: {
        backgroundColor: "var(--button-danger-secondary-bg-disabled)",
        color: "var(--button-danger-secondary-text-disabled)",
        border: "1px solid var(--button-danger-secondary-border)",
      },
    },
  },
  link: {
    default: {
      normal: {
        backgroundColor: "transparent",
        color: "var(--color-primary)",
        border: "0",
        boxShadow: "none",
        fontWeight: "600",
      },
      hover: {
        border: "0",
        textDecoration: "underline",
        textDecorationThickness: "1px",
        textUnderlineOffset: "4px",
      },
      focus: {
        border: "0",
        textDecoration: "underline",
        textDecorationThickness: "1px",
        textUnderlineOffset: "4px",
      },
      disabled: {
        backgroundColor: "var(--button-secondary-bg-disabled)",
        color: "var(--button-secondary-text-disabled)",
        border: "1px solid var(--button-secondary-border)",
      },
    },
    danger: {
      normal: {
        backgroundColor: "transparent",
        color: "var(--button-danger-secondary-text)",
        border: "0",
        boxShadow: "none",
      },
      hover: {
        backgroundColor: "var(--button-danger-secondary-bg-hover)",
        color: "var(--button-danger-secondary-text)",
        border: "0",
        textDecoration: "underline",
        textDecorationThickness: "1px",
        textUnderlineOffset: "4px",
      },
      focus: {
        backgroundColor: "var(--button-danger-secondary-bg-focus)",
        color: "var(--button-danger-secondary-text)",
        border: "0",
      },
      disabled: {
        backgroundColor: "var(--button-danger-secondary-bg-disabled)",
        color: "var(--button-danger-secondary-text-disabled)",
        border: "1px solid var(--button-danger-secondary-border)",
      },
    },
  },
  icon: {
    default: {
      normal: {
        backgroundColor: "transparent",
        color: "var(--button-secondary-text)",
        border: "0",
        boxShadow: "none",
      },
      hover: {
        backgroundColor: "var(--button-secondary-bg-hover)",
        border: "0",
      },
      focus: {
        backgroundColor: "var(--button-secondary-bg-focus)",
        color: "var(--button-primary-text)",
        border: "0",
      },
      disabled: {
        backgroundColor: "var(--button-secondary-bg-disabled)",
        color: "var(--button-secondary-text-disabled)",
        border: "0",
      },
    },
    border: {
      normal: {
        backgroundColor: "transparent",
        color: "var(--button-secondary-text)",
        border: "1px solid var(--button-secondary-border)",
        boxShadow: "none",
      },
      hover: {
        backgroundColor: "var(--button-secondary-bg-hover)",
        border: "1px solid var(--button-secondary-border)",
      },
      focus: {
        backgroundColor: "var(--button-secondary-bg-focus)",
        color: "var(--button-primary-text)",
        border: "1px solid var(--button-secondary-border)",
      },
      disabled: {
        backgroundColor: "var(--button-secondary-bg-disabled)",
        color: "var(--button-secondary-text-disabled)",
        border: "1px solid var(--button-secondary-border)",
      },
    },
    white: {
      normal: {
        backgroundColor: "var(--color-white)",
        color: "var(--button-secondary-text)",
        border: "1px solid var(--button-secondary-border)",
        boxShadow: "none",
      },
      hover: {
        backgroundColor: "var(--button-primary-bg)",
        color: "var(--button-primary-text)",
        border: "1px solid var(--button-primary-bg)",
      },
      focus: {
        backgroundColor: "var(--button-primary-bg)",
        color: "var(--button-primary-text)",
        border: "1px solid var(--button-primary-bg)",
      },
      disabled: {
        backgroundColor: "var(--button-secondary-bg-disabled)",
        color: "var(--button-secondary-text-disabled)",
        border: "1px solid var(--button-secondary-border)",
      },
    },
    danger: {
      normal: {
        backgroundColor: "var(--button-danger-secondary-bg)",
        color: "var(--button-danger-secondary-text)",
        border: "0",
        boxShadow: "none",
      },
      hover: {
        backgroundColor: "var(--button-danger-secondary-bg-hover)",
        color: "var(--button-danger-secondary-text)",
        border: "0",
      },
      focus: {
        backgroundColor: "var(--button-danger-secondary-bg-focus)",
        color: "var(--button-danger-secondary-text)",
        border: "0",
      },
      disabled: {
        backgroundColor: "var(--button-danger-secondary-bg-disabled)",
        color: "var(--button-danger-secondary-text-disabled)",
        border: "0",
      },
    },
  },
};
